import BaseTable from 'components/Tables/BaseTable';
import { actions as productActions } from 'ducks/products';
import { actions as productStepsActions } from 'ducks/productSteps';
import { sortBy } from 'lodash';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { groupBy } from 'selectors/generic';
import tableIcons from 'utils/icons/materialTableIcons';
import columns from 'utils/tables/columns/product/productSteps';
import { currentUser } from 'selectors/currentUser';

// A step's `substeps` and a product's `product_steps` both used to arrive
// nested; both are the same slice read by a different column.
const substepsByStep = groupBy('steps', 'master_step_id');
const productStepsByProduct = groupBy('productSteps', 'product_id');

const Component = props => {
  let { flowSteps, productsById, productId, productSteps, substeps, user } = props;
  const { createProductStep, fetchProduct, handleCloseDrawer, removeProductStep } = props;

  const [unselectedIds, setUnselectedIds] = useState([]);
  const [loading, setLoading] = useState(false);

  const isPickable = fs => (substeps[fs.id] || []).length === 0 || fs.master_step_id !== null;

  useEffect(() => {
    const flowStepIds = flowSteps
      .filter(isPickable)
      .map(fs => fs.id);

    setUnselectedIds(
      (productSteps[productId] || [])
        .filter(s => flowStepIds.includes(s.step_id))
        .map(s => s.step_id)
    );
  }, [productsById]);

  const pickableflowSteps = flowSteps.filter(isPickable);
  const steps = pickableflowSteps.map(step =>
    !unselectedIds.includes(step.id) ?
      { ...step, tableData: { checked: true } } :
      { ...step, tableData: { checked: false } }
  );
  const orderedSteps = sortBy(steps, [row => unselectedIds.includes(row.id), 'id']);

  return (
    <BaseTable
      titleBack={true}
      titleAction={handleCloseDrawer}
      title={`ETAPAS - ${productsById[productId].code} - ${productsById[productId].name}`}
      icons={tableIcons}
      columns={columns(user)}
      data={orderedSteps}
      order={false}
      onRowClick={() => null}
      options={{
        selection: true,
        showTextRowsSelected: false,
        showSelectAllCheckbox: false
      }}
      isLoading={loading}
      onSelectionChange={(rows, difRow) => {
        setLoading(true);

        const unselectedRows = steps.length - rows.length;
        if ( unselectedRows > unselectedIds.length) {
          createProductStep({ step_id: difRow.id, product_id: productId })
            .then(() => fetchProduct(productId))
            .then(() => setLoading(false))
            .catch(e => {
              setLoading(false);
              alert(e);
            });
        } else {
          const productStepToDel = (productSteps[productId] || [])
            .find(ps => ps.step_id === difRow.id);
          removeProductStep(productStepToDel.id)
            .then(() => fetchProduct(productId))
            .then(() => setLoading(false))
            .catch(e => {
              setLoading(false);
              alert(e);
            });

        }
      }}
    />
  );
};

const mapStateToProps = (state) => ({
  productsById: state.products.models,
  productSteps: productStepsByProduct(state),
  substeps: substepsByStep(state),
  user: currentUser(state)
});

const mapDispatchToProps = dispatch => ({
  fetchProduct: (id) => dispatch(productActions.fetchOne(id)),
  createProductStep: data => dispatch(productStepsActions.createPromise(data)),
  removeProductStep: id => dispatch(productStepsActions.removePromise(id))
});

export default connect(mapStateToProps, mapDispatchToProps)(Component);
